import React from 'react';
import { MapPin, Mail, Globe, Building2 } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { SEO } from '../components/SEO';
export function Contact() {
  const {
    t,
    language
  } = useLanguage();
  const seoTitles = {
    en: 'Contact NEW ASIA TECH - Pekanbaru, Indonesia | Sovereign Technology Solutions',
    id: 'Hubungi NEW ASIA TECH - Pekanbaru, Indonesia | Solusi Teknologi Berdaulat'
  };
  const seoDescriptions = {
    en: 'Contact NEW ASIA TECH (PT NETKRIDA TUAH CAKRAWALA) in Pekanbaru, Riau, Indonesia. Email: contact@newasiatech.co.id. Sovereign technology solutions for government and institutional partners across Asia.',
    id: 'Hubungi NEW ASIA TECH (PT NETKRIDA TUAH CAKRAWALA) di Pekanbaru, Riau, Indonesia. Email: contact@newasiatech.co.id. Solusi teknologi berdaulat untuk mitra pemerintah dan institusional di seluruh Asia.'
  };
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: 'NEW ASIA TECH',
    legalName: 'PT NETKRIDA TUAH CAKRAWALA',
    image: 'https://newasiatech.co.id/logo.png',
    '@id': 'https://newasiatech.co.id',
    url: 'https://newasiatech.co.id',
    telephone: '',
    email: 'contact@newasiatech.co.id',
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Savana Cluster, A2, Jl. Karya Bakti, Tengkerang Bar.',
      addressLocality: 'Kec. Marpoyan Damai, Pekanbaru',
      addressRegion: 'Riau',
      postalCode: '28282',
      addressCountry: 'ID'
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: 0.4798687,
      longitude: 101.4313303
    },
    openingHoursSpecification: {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
      opens: '09:00',
      closes: '17:00'
    },
    sameAs: ['https://netkrida.co.id']
  };
  return <>
      <SEO title={seoTitles[language]} description={seoDescriptions[language]} url="/contact" type="website" data-id="element-236" />

      <script type="application/ld+json" data-id="element-237">
        {JSON.stringify(structuredData)}
      </script>

      <div className="min-h-screen pt-32 pb-20 px-6" data-id="element-238">
        <div className="max-w-[1800px] mx-auto" data-id="element-239">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-24" data-id="element-240">
            <div className="animate-fade-in-up" data-id="element-241">
              <h1 className="text-5xl md:text-7xl font-display font-bold text-ivory mb-8" data-id="element-242">
                {t('contact.title')}
              </h1>
              <p className="text-xl text-gray-400 mb-16 max-w-md leading-relaxed" data-id="element-243">
                {t('contact.desc')}
              </p>

              <div className="space-y-12" data-id="element-244">
                <div className="flex items-start group" data-id="element-245">
                  <div className="p-4 bg-white/5 rounded mr-6 group-hover:bg-muted-gold/20 transition-colors duration-300 border border-white/10" data-id="element-246">
                    <Building2 className="w-7 h-7 text-muted-gold" data-id="element-247" />
                  </div>
                  <div data-id="element-248">
                    <div className="text-xs font-mono text-muted-gold mb-3 uppercase tracking-widest" data-id="element-249">
                      {t('contact.entity')}
                    </div>
                    <p className="text-lg text-ivory font-semibold mb-2" data-id="element-250">
                      PT NETKRIDA TUAH CAKRAWALA
                    </p>
                    <p className="text-gray-400" data-id="element-251">{t('contact.registered')}</p>
                  </div>
                </div>

                <div className="flex items-start group" data-id="element-252">
                  <div className="p-4 bg-white/5 rounded mr-6 group-hover:bg-ai-teal/20 transition-colors duration-300 border border-white/10" data-id="element-253">
                    <MapPin className="w-7 h-7 text-ai-teal" data-id="element-254" />
                  </div>
                  <div data-id="element-255">
                    <div className="text-xs font-mono text-ai-teal mb-3 uppercase tracking-widest" data-id="element-256">
                      {t('contact.headquarters')}
                    </div>
                    <address className="text-lg text-ivory leading-relaxed not-italic" data-id="element-257">
                      Savana Cluster, A2
                      <br data-id="element-258" />
                      Jl. Karya Bakti, Tengkerang Bar.
                      <br data-id="element-259" />
                      Kec. Marpoyan Damai
                      <br data-id="element-260" />
                      Pekanbaru, Riau 28282
                      <br data-id="element-261" />
                      Indonesia
                    </address>
                  </div>
                </div>

                <div className="flex items-start group" data-id="element-262">
                  <div className="p-4 bg-white/5 rounded mr-6 group-hover:bg-neural-green/20 transition-colors duration-300 border border-white/10" data-id="element-263">
                    <Mail className="w-7 h-7 text-neural-green" data-id="element-264" />
                  </div>
                  <div data-id="element-265">
                    <div className="text-xs font-mono text-neural-green mb-3 uppercase tracking-widest" data-id="element-266">
                      {t('contact.email')}
                    </div>
                    <a href="mailto:contact@newasiatech.co.id" className="text-lg text-ivory hover:text-ai-teal transition-colors" data-id="element-267">
                      contact@newasiatech.co.id
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div className="animate-fade-in-up delay-200" data-id="element-268">
              <div className="w-full h-[500px] bg-carbon border border-white/10 rounded-lg overflow-hidden relative group mb-8" data-id="element-269">
                <div className="absolute inset-0 bg-tech-grid opacity-20" data-id="element-270" />
                <div className="absolute inset-0 bg-gradient-to-t from-carbon via-transparent to-transparent" data-id="element-271" />

                <div className="absolute inset-0 flex items-center justify-center" data-id="element-272">
                  <div className="relative" data-id="element-273">
                    <div className="w-4 h-4 bg-ai-teal rounded-full animate-ping absolute" data-id="element-274" />
                    <div className="w-4 h-4 bg-ai-teal rounded-full absolute" data-id="element-275" />
                    <div className="absolute -top-8 left-1/2 -translate-x-1/2 whitespace-nowrap" data-id="element-276">
                      <div className="text-xs font-mono text-ai-teal bg-carbon/90 px-3 py-1 rounded border border-ai-teal/30" data-id="element-277">
                        PEKANBARU, RIAU
                      </div>
                    </div>
                  </div>
                </div>

                <div className="absolute bottom-4 left-4 right-4 glass-panel p-4 rounded" data-id="element-278">
                  <div className="text-[10px] font-mono text-graphite mb-1" data-id="element-279">
                    COORDINATES
                  </div>
                  <div className="text-xs text-ivory font-mono" data-id="element-280">
                    0.4798687° N, 101.4313303° E
                  </div>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-281">
                <div className="bg-white/[0.02] border border-white/10 p-6 hover:border-ai-teal/30 transition-colors duration-300" data-id="element-282">
                  <Globe className="w-8 h-8 text-muted-gold mb-4" data-id="element-283" />
                  <h3 className="text-sm font-mono text-muted-gold uppercase tracking-widest mb-2" data-id="element-284">
                    {t('contact.hub.title')}
                  </h3>
                  <p className="text-gray-400 text-sm" data-id="element-285">
                    {t('contact.hub.desc')}
                  </p>
                </div>

                <div className="bg-white/[0.02] border border-white/10 p-6 hover:border-ai-teal/30 transition-colors duration-300" data-id="element-286">
                  <Building2 className="w-8 h-8 text-ai-teal mb-4" data-id="element-287" />
                  <h3 className="text-sm font-mono text-ai-teal uppercase tracking-widest mb-2" data-id="element-288">
                    {t('contact.enterprise.title')}
                  </h3>
                  <p className="text-gray-400 text-sm" data-id="element-289">
                    {t('contact.enterprise.desc')}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-32 text-center border-t border-white/10 pt-16 animate-fade-in-up delay-300" data-id="element-290">
            <h2 className="text-3xl md:text-5xl font-display font-bold text-ivory mb-6" data-id="element-291">
              {t('contact.cta.title')}
            </h2>
            <p className="text-gray-400 mb-8 max-w-2xl mx-auto" data-id="element-292">
              {t('contact.cta.desc')}
            </p>
            <a href="mailto:contact@newasiatech.co.id" className="inline-block border border-white/20 px-12 py-4 text-sm font-bold uppercase tracking-[0.2em] text-ivory hover:bg-white hover:text-carbon transition-all duration-300 hover:shadow-[0_0_30px_rgba(255,255,255,0.2)]" data-id="element-293">
              {t('contact.cta.button')}
            </a>
          </div>
        </div>
      </div>
    </>;
}